import { render, staticRenderFns } from "./Pay.vue?vue&type=template&id=4f7b4e5f"
import script from "./Pay.js?vue&type=script&lang=js&external"
export * from "./Pay.js?vue&type=script&lang=js&external"
import style0 from "./Pay.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports